export default __webpack_public_path__ + "8ad95406340d4d9b1f80b9b25ea18e39.png";